/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StageWithResults } from './StageWithResults';
import {
    StageWithResultsFromJSON,
    StageWithResultsFromJSONTyped,
    StageWithResultsToJSON,
    StageWithResultsToJSONTyped,
} from './StageWithResults';

/**
 * 
 * @export
 * @interface CategoryWithResults
 */
export interface CategoryWithResults {
    /**
     * 
     * @type {string}
     * @memberof CategoryWithResults
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryWithResults
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryWithResults
     */
    gender?: string;
    /**
     * 
     * @type {Array<StageWithResults>}
     * @memberof CategoryWithResults
     */
    stages?: Array<StageWithResults>;
}

/**
 * Check if a given object implements the CategoryWithResults interface.
 */
export function instanceOfCategoryWithResults(value: object): value is CategoryWithResults {
    return true;
}

export function CategoryWithResultsFromJSON(json: any): CategoryWithResults {
    return CategoryWithResultsFromJSONTyped(json, false);
}

export function CategoryWithResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryWithResults {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'stages': json['stages'] == null ? undefined : ((json['stages'] as Array<any>).map(StageWithResultsFromJSON)),
    };
}

export function CategoryWithResultsToJSON(json: any): CategoryWithResults {
    return CategoryWithResultsToJSONTyped(json, false);
}

export function CategoryWithResultsToJSONTyped(value?: CategoryWithResults | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'gender': value['gender'],
        'stages': value['stages'] == null ? undefined : ((value['stages'] as Array<any>).map(StageWithResultsToJSON)),
    };
}

